import React from 'react';
import { AutoCenter } from 'antd-mobile';
import { Typography } from 'antd';

const { Title, Text, Paragraph } = Typography;

const TermsParagraph = () => (
  <>
    <Title level={5}>
      <AutoCenter>和運租車股份有限公司</AutoCenter>
    </Title>
    <Title level={5}>
      <AutoCenter>會員隱私權條款</AutoCenter>
    </Title>
    <br />
    <Paragraph>
      <Text strong>公告日期：西元 2024 年 05 月 23 日</Text>
    </Paragraph>
    <Paragraph>
      <Text strong>文件版本：V. 1</Text>
    </Paragraph>
    <br />
    <Paragraph>親愛的客戶，您好</Paragraph>
    <Paragraph>
      感謝您選擇和運租車股份有限公司（以下簡稱「和運租車」）為您提供服務，謹依《個人資料保護法》之規定，向您說明和運租車蒐集您個人資料之目的、方式、種類、處理、利用的範圍、您得向和運租車行使的相關權利，以及未提供完整資料將可能對您權益所造成的影響等事項。請您務必閱讀以下本條款內容，若您不同意本條款之全部或部分內容，請您停止使用和運租車產品及服務；您向和運租車提供個人資料或使用和運租車的產品或服務時，即表示您同意以下條款內容。
    </Paragraph>
    <Text strong>一、條款適用範圍</Text>
    <Paragraph>
      本條款及其所包含的告知事項，僅適用於和運租車所提供的產品及服務（包括但不限於相關資訊所載之網站、軟體應用程式、社交媒體網頁、電子郵件訊息或其他數位服務，以下合稱「數位服務」）。您使用和運租車數位服務所提供的其他外部網站、應用程式的連結，或其他合作夥伴所提供的服務（以上合稱外部網站）時，有關外部網站隱私權保護政策及其與個人資料保護有關的告知事項，敬請參閱各外部網站所提供的隱私權保護政策及會員使用條款。
    </Paragraph>
    <Text strong>二、個人資料蒐集之主體</Text>
    <Paragraph>和運租車可藉由提供的產品及服務蒐集您的相關個人資料。</Paragraph>
    <Text strong>三、個人資料蒐集之目的</Text>
    <Paragraph>
      和運租車基於《個人資料保護法》相關法令，向您告知和運租車直接自您或自第三人處蒐集您的個人資料，且依據法務部頒佈「個人資料保護法之特定目的及個人資料之類別」，基於下列特定目的向您蒐集、處理及利用您的個人資料：○○一
      人身保險業務、○○七 不動產服務、○一○ 公立與私立慈善機構管理、○一三
      公共關係、○二○ 代理與仲介業務、○二九
      公民營（辦）交通運輸、公共運輸及公共建設、○四○ 行銷
      (包括金控共同行銷業務)、○四四 投資管理、○五二
      法人或團體對股東、會員（含股東、會員指派之代表）、董事、監察人、理事、監事或其他成員名冊之內部管理、○六一
      金融監督、管理與檢查、○六五 保險經記、代理、公證業務、○六六
      保險監理、○六七 信用卡、現金卡、轉帳卡或電子票證業務、○六九
      契約、類似契約或其他法律關係事務、○七五 科技行政、○七七
      訂位、住宿登記與購票業務、○八一 個人資料之合法交易業務、○八八
      核貸與授信業務、○九○ 消費者、客戶管理與服務、○九一 消費者保護、○九三
      財產保險、○九四 財產管理、○九八 商業與技術資訊、一○六 授信業務、一○七
      採購與供應管理、一一二 票據交換業務、一一六 場所進出安全管理、一二九
      會計與相關服務、一三六 資（通）訊與資料庫管理、一三七
      資通安全與管理、一四八 網路購物及其他電子商務服務、一五四 徵信、一五七
      調查、統計與研究分析、一七○
      觀光行政、觀光旅館業、旅館業、旅行業、觀光遊樂業及民宿經營管理業務、一七七
      其他金融管理業務、一八一
      其他經營合於營業登記項目或組織章程所定之業務、一八二
      其他諮詢與顧問服務，以及和運租車為提供及持續改善產品、服務以及與個人資料使用對象所營事業具合理關聯之其他特定目的。
    </Paragraph>
    <Text strong>四、個人資料蒐集之類別</Text>
    <Paragraph>
      蒐集個人資料之類別依據法務部頒佈「個人資料保護法之特定目的及個人資料之類別」，和運租車藉由向您提供的產品及服務，可能向您蒐集下列類別的個人資料：辨識個人者（姓名、電話、網路平臺申請之帳號、電子郵遞地址、住址等）、政府資料中之辨識者（身分證統一編號、護照號碼、居留證號碼等）、辨識財務者（保險單號碼、信用卡或簽帳卡之號碼等）、保險細節（保險類別、保險範圍、保險費、保險金額等）、個人描述（性別、出生年月日、國籍等）、家庭情形（結婚有無等）、旅行及其他遷徙細節（駕駛車輛定位資訊）、生活格調（使用消費品之種類及服務之細節、個人或家庭之消費模式等）、執照或其他許可（駕駛執照、行車執照等）、資料主體所取得之財貨或服務（貨物或服務之有關細節等）、資料主體之商業活動（提供或使用之財貨或服務、商業契約）、其他（連線車載資訊記錄檔資料、網站留言、系統自動紀錄之軌跡資訊及其他得以直接或間接識別使用者身分之個人資料等），惟將以您實際提供和運租車之個人資料為限。
    </Paragraph>
    <Text strong>五、個人資料利用之期間、對象、地區、及方式</Text>
    <Paragraph>
      (一)
      期間：和運租車為提供您產品及服務而蒐集您的個人資料，您的個人資料將用於上述特定目的範圍與目的存續期間內，於中華民國境內及海外伺服器為必要之處理、利用。此外，必要時您的個人資料可能用於和運租車為您所提供的海外產品或服務。在上述特定目的之存續期間、相關法令規定之應保存期間、因執行業務所必須之保存期間，或依個別契約就資料保存所定之保存年限內，和運租車將持續保存您的個人資料。
      (二)
      對象：經您同意有權運用您留存於和運租車個人資料之合作廠商、和運租車之子公司、海外分支機構、委外之協力廠商（例如：商品或服務之供應商以及提供各種資訊服務、數據分析服務、物流、金流或活動贈品、展示品、協尋車輛、催收之廠商），及對和運租車有管轄權之中央或地方之目的事業主管機關、司法主管機關、依法有調查權之機關或其他政府機構，及其他和運租車之交易相對人而有蒐集、處理、利用及國際傳輸個人相關資料必要者。您的個人資料如為和運租車與其他廠商共同蒐集者，將於該共同蒐集之活動中另行載明蒐集主體，非經您的同意或其他法令之特別規定，或行政機關依法所提出之命令或要求，和運租車不會將您的個人資料揭露予第三人或使用於蒐集目的以外之其他用途。
      (三)
      除前述(二)利用對象外，您知悉並同意利用對象範圍亦及於未來和運租車、或前述各利用對象公司於官方網站，或以其他公告方式所增加之公司。詳見和運租車官網。
      (四)
      地區：前揭利用對象之中華民國境內及必要時可能用於前揭利用對象為您提供相關服務之境外地區。
      (五)
      方式：符合相關法令以自動化或其他非自動化之利用方式，例如使用電子文件、紙本或其他合於當時技術之適當方式等。
      (六) 通知型訊息說明條款：
      和運租車將以通知型訊息傳送重要訊息給您。即使未加入和運租車/數位服務好友，您仍可接收到通知型訊息。和運租車傳送之通知型訊息以對您有效且重要的訊息為限，以廣告或其他目的的訊息皆不會被傳送。滿足以下三個條件者，將可收到通知型訊息。
      (1)LINE帳號設定電話號碼與和運租車/數位服務所傳來的電話號碼比對相符。
      (2)該LINE帳號已在LINE APP設定中，同意接收通知型訊息。
      (3)LINE帳號未封鎖傳送訊息之LINE官方帳號。
      欲變更通知型訊息的設定，操作如下： (3.1) 點選「主頁」＞「設定」 (3.2)
      點選「隱私設定」 (3.3) 點選「提供使用資料」 (3.4) 點選「LINE通知型訊息」
      (3.5) 開關「接收LINE通知型訊息」。
      關閉「接收通知型訊息」後，將不會接收到來自任何企業官方帳號或認證官方帳號的通知型訊息。
    </Paragraph>
    <Text strong>六、個人資料當事人權利行使</Text>
    <Paragraph>
      (一)
      依據個人資料保護法第三條規定，您可就和運租車所保有並屬於您的個人資料，致電和運租車客服專線0800-024-550，行使下列權利：
      1. 查詢或請求閱覽或請求製給複製本，和運租車依法得酌收必要合理費用； 2.
      請求補充或更正，惟依法您應提供相關資料並為適當之釋明； 3.
      請求停止蒐集、處理或利用及請求刪除，惟和運租車係依法令執行業務所必須者，得不依您的請求為之。
      (二)
      若您擬行使上述任一權利，請檢附相關證明文件向和運租車提出書面請求，和運租車將於收到書面請求之次日起15日內書面通知您准否之決定（前述15日期間於必要時，得予再延長15日）。如係請求查詢或閱覽文件，您應於收受通知後於指定期間內，至和運租車指定之地點查詢或閱覽。如您逾期未查詢或閱覽文件者，則需向和運租車重新提出書面請求。
      (三)
      除與您所申辦之業務有關電話及簡訊通知或郵件（含帳單及發票）寄送等必要通訊，若您不欲接獲其他行銷郵件或通訊，您可致電和運租車客服專線0800-024-550，將由專人為您說明及辦理。
    </Paragraph>
    <Text strong>七、未提供個人資料的權益影響</Text>
    <Paragraph>
      您得自由選擇是否提供個人資料，如您未能完整提供和運租車所須蒐集的個人資料，和運租車將可能婉謝、延遲或無法提供您和運租車產品及服務。
    </Paragraph>
    <Text strong>八、網路瀏覽器Cookies之使用</Text>
    <Paragraph>
      當您使用和運租車提供之數位服務時，和運租車可能會自動接收並紀錄您瀏覽器上的伺服器數值，包括網路協定位址（IP
      Address）、Cookies資料、瀏覽及點選網頁紀錄等，於上述特定目的必要範圍內，作為和運租車增進數位服務的參考依據。如果您不想提供cookie紀錄，您可以透過更改瀏覽器的設定以取消或限制cookie的使用，設定方法請參閱您的瀏覽器說明。為了提供您最佳的服務，和運租車可能會使用
      Web
      Beacons在您的行動裝置上設定並取用和運租車的Cookies，以追蹤您在和運租車提供之數位服務的活動。若和運租車提供之數位服務有提供廣告，則提供該廣告的公司可能在您的行動裝置上設定並取用Cookies，該廣告公司將根據其自訂的隱私權保護政策蒐集、處理及利用Cookies，其自訂的隱私權保護政策可能與本條款之Cookies規範不同，但該廣告公司不能使用和運租車提供之數位服務所蒐集的Cookies記錄。
    </Paragraph>
    <Text strong>九、其他隱私權保護相關事項</Text>
    <Paragraph>
      (一)
      和運租車可能於上述特定目的必要範圍內，透過Facebook、LINE或類似的社群服務系統，於已取得您的同意後，將和運租車產品及服務的資訊發布於您的社群活動資訊頁面，若您不同意該等訊息之發布，請您勿點選同意鍵，或於事後透過各該社群服務之會員機制移除該等資訊或拒絕和運租車繼續發布相關訊息。若有任何問題，仍可與和運租車聯絡，和運租車將協助您確認、處理相關問題。
      (二)
      若您提供予和運租車的個人資料並非您本人之個人資料，您應確定依法有權或已事前取得個人資料當事人同意由您代理將其個人資料提供予和運租車，並已代和運租車就本條款之內容告知個人資料當事人
      (三)
      當和運租車之全部或部分有分割、獨立子公司經營、被其他第三者購併或收購資產，導致和運租車或和運租車數位服務平台（包括但不限於網站、軟體及應用程式等）之經營權轉換時，和運租車會於事前將相關細節公告於本公司官方網站，且和運租車所擁有之全部或部分使用者資訊亦可能在經營權轉換的狀況下移轉給第三人，惟限於與該經營權轉換服務相關之個人資料。若當和運租車或和運租車數位服務平台之部分營運移轉予第三人後，您不希望和運租車繼續利用您的個人資料，您可以依本條款向和運租車行使相關權利。
      (四)
      為了保護您的帳戶及個人資料的安全，請您不要任意將個人於和運租車數位服務平台的帳號、密碼提供予第三人，或允許第三人以您的個人資料申請帳號、密碼，以避免您將自行承擔相關風險及責任的可能。若您的帳號、密碼有外洩之虞，請您立即更改密碼，或通知和運租車暫停該帳號使用服務權利（屆時和運租車將可能核對您的個人資料）。
      (五) 基於全球各區域間的政策及法令差異，當您位於歐洲聯盟（European
      Union）會員國境內使用和運租車提供之數位服務時，您取得、使用或接受和運租車提供之數位服務的權限可能有限制。故若您於歐洲聯盟會員國境內，將可能無法取得、使用或接受和運租車提供之數位服務，敬請見諒。
    </Paragraph>
    <Text strong>十、條款修訂</Text>
    <Paragraph>
      (一)
      和運租車有權因應相關法令的修訂或其他環境變遷等因素，隨時修訂本告知事項，您同意本條款時，即代表您同意和運租車於修訂後，得以言詞、書面、電話、簡訊、電子郵件、傳真、數位平台公告或其他足以使您知悉或可得知悉之方式(包括但不限於以前述方式告知提供詳載本告知事項內容之網站連結)，亦同意和運租車得不另行將修訂要點各別通知您，若您不同意本條款的變更或修改，請停止繼續使用和運租車產品及服務，並依本條款規定通知和運租車停止蒐集、處理及利用您的個人資料。
      (二)
      如您與和運租車先前簽訂之契約或其他書面文件關於個人資料之蒐集、處理、利用、國際傳輸有關條款與本條款有所歧異者，以本條款為準。
    </Paragraph>
  </>
);

export default TermsParagraph;
